import { render, staticRenderFns } from "./GatBottomPanel.vue?vue&type=template&id=2a6ce3ba&scoped=true&"
import script from "./GatBottomPanel.vue?vue&type=script&lang=js&"
export * from "./GatBottomPanel.vue?vue&type=script&lang=js&"
import style0 from "./GatBottomPanel.vue?vue&type=style&index=0&id=2a6ce3ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6ce3ba",
  null
  
)

export default component.exports